import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { TinhTrangHoSo } from 'src/app/shared/TinhTrangHoSo.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class TinhTrangHoSoService extends BaseService{
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "TinhTrangHoSo";
    }
}

